import { Box, CircularProgress } from '@mui/material';
import React from 'react';

export interface IPageLoaderProperties {
  minHeight?: string | number;
  size?: number;
}

export const PageLoader = ({ minHeight = '50vh', size = 40 }: IPageLoaderProperties) => {
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        minHeight,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <CircularProgress color="secondary" size={size} />
    </Box>
  );
};
